import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import apiClient from '../api/client';
import { Run } from '../types';
import TrainingRunDetails from '../components/TrainingRunDetails';

const Demo: React.FC = () => {
  const navigate = useNavigate();
  const [run, setRun] = useState<Run | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadDemo = async () => {
      try {
        const res = await apiClient.get('/api/v1/demo/run');
        setRun(res.data);
      } catch (e) {
        setError('Demo not available');
      } finally {
        setLoading(false);
      }
    };
    loadDemo();
  }, []);

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress sx={{ color: '#EF8997' }} />
      </Box>
    );
  }

  if (error || !run) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography color="text.secondary">{error || 'Demo not available'}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#000' }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 4,
          py: 2,
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img src="/exo-logo.png" alt="Exo" style={{ height: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Canard
          </Typography>
          <Typography
            variant="caption"
            sx={{
              bgcolor: 'rgba(239,137,151,0.15)',
              color: '#EF8997',
              px: 1,
              py: 0.25,
              borderRadius: 0.5,
              fontWeight: 600,
              fontSize: 11,
            }}
          >
            DEMO
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            size="small"
            onClick={() => navigate('/login')}
            sx={{ color: 'rgba(255,255,255,0.7)', textTransform: 'none' }}
          >
            Sign in
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => navigate('/signup')}
            sx={{
              bgcolor: '#EF8997',
              color: '#000',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': { bgcolor: '#e07080' },
            }}
          >
            Sign up
          </Button>
        </Box>
      </Box>

      {/* Run details */}
      <Box sx={{ p: 4 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight: 600 }}>
            {run.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {run.config?.training_config?.task_name || 'RL policy'} trained with Isaac Lab + PPO
          </Typography>
        </Box>
        <TrainingRunDetails run={run} apiBasePath="/api/v1/demo/run" />
      </Box>
    </Box>
  );
};

export default Demo;
